import { ENV } from '../../../../server/config';

export const DEPLOYMENT_ENV = {
    LOCAL: 'local',
    DEV: 'dev',
    TEST: 'test',
    PROD: 'prod',
} as const;

export type DeploymentEnv =
    (typeof DEPLOYMENT_ENV)[keyof typeof DEPLOYMENT_ENV];

export const isDevEnvironment = (): boolean =>
    ENV === DEPLOYMENT_ENV.LOCAL || ENV === DEPLOYMENT_ENV.DEV;

export const isLocalEnvironment = (): boolean => ENV === DEPLOYMENT_ENV.LOCAL;
